import { render, staticRenderFns } from "./SelectionsBox.vue?vue&type=template&id=667c29fa&scoped=true&"
import script from "./SelectionsBox.vue?vue&type=script&lang=js&"
export * from "./SelectionsBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectionsBox.vue?vue&type=style&index=0&id=667c29fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c29fa",
  null
  
)

export default component.exports